import TextLabelTile from "./TextLabelTile";

export default TextLabelTile